"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
exports.createEventClass = createEventClass;
const zod_1 = require("zod");
class Event {
    static validateEmission(data) {
        return this.emissionSchema.parse(data);
    }
    static getName() {
        return this.eventName;
    }
    static getEmissionKeys() {
        return this.emissionSchema instanceof zod_1.z.ZodObject ? Object.keys(this.emissionSchema.shape) : [];
    }
}
exports.Event = Event;
function createEventClass(eventName, emissionSchema) {
    const fullSchema = emissionSchema.extend({ timeGenerated: zod_1.z.date(), dataIsValid: zod_1.z.boolean().optional() });
    return class extends Event {
        static { this.eventName = eventName; }
        static { this.schema = fullSchema; }
        static { this.emissionSchema = emissionSchema; }
    };
}
//# sourceMappingURL=event.js.map